module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq414-be3516476bde59149c4a6f637fdaa4cd.jpg";